const validate = (attrs = {
  horarios: [],
}) => {
  const errors = {};

  if (!attrs.malla || !attrs.malla.value) {
    errors.malla = 'Debe seleccionar una malla';
  }

  if (!attrs.periodo || !attrs.periodo.value) {
    errors.periodo = 'Debe seleccionar un periodo';
  }

  if (!attrs.materia || !attrs.materia.value) {
    errors.materia = 'Debe seleccionar una materia';
  }

  if (!attrs.profesor || !attrs.profesor.value) {
    errors.profesor = 'Debe seleccionar un profesor';
  }

  if (attrs.horarios && attrs.horarios.length) {
    errors.horarios = [];
    attrs.horarios.filter(o => !o.deleted).forEach((obj, index) => {
      const error = {};

      if (!obj.tipoActividadAcademicaHorario || !obj.tipoActividadAcademicaHorario.value) {
        error.tipoActividadAcademicaHorario = 'Debe ingresar el tipo de actividad academica';
      }
      if (!obj.profesor || !obj.profesor.value) {
        error.profesor = 'Debe seleccionar un profesor';
      } else {
        const {
          profesor, profesorAuxiliar1, profesorAuxiliar2, profesorAuxiliar3,
        } = attrs;
        const profesorsAvailable = [
          profesor || {},
          profesorAuxiliar1 || {},
          profesorAuxiliar2 || {},
          profesorAuxiliar3 || {},
        ];

        if (!profesorsAvailable.some(p => p.value && p.value === obj.profesor.value)) {
          error.profesor = 'Debe seleccionar el profesor encaregado o auxiliar';
        }
      }
      if (!obj.dia || !obj.dia.value) {
        error.dia = 'Debe seleccionar un dia';
      }
      if (!obj.horaInicio) {
        error.horaInicio = 'Debe ingresar la hora';
      }
      if (!obj.horaFin) {
        error.horaFin = 'Debe ingresar la hora';
      }

      if (Object.keys(error).length) {
        errors.horarios[index] = error;
      }
    });
  }

  if (Object.keys(errors).length) {
    console.error(errors);
  }

  return errors;
};

export default validate;
